import { ButtonV2, IconDownload } from '@moneyforward/ap-frontend-components';
import classNames from 'classnames/bind';
import { FC, memo, useCallback } from 'react';
import { useDownloadSampleCsv } from './hooks/useDownloadSampleCsv';
import styles from './styles.module.scss';
import { useTranslation } from '@/i18n';

const cx = classNames.bind(styles);

type PayeeType = 'payee' | 'instant_payee';

export type SampleCsvDownloadButtonsProps = {
  payeeType: PayeeType;
};

export const SampleCsvDownloadButtons: FC<SampleCsvDownloadButtonsProps> = memo(
  ({ payeeType }) => {
    const { t } = useTranslation();
    const handleDownloadLink = useDownloadSampleCsv();

    const handleUtf8 = useCallback(
      () =>
        void handleDownloadLink({ payee_type: payeeType, csv_encode: 'utf-8' }),
      [handleDownloadLink, payeeType]
    );
    const handleShiftJis = useCallback(
      () =>
        void handleDownloadLink({
          payee_type: payeeType,
          csv_encode: 'shift_jis',
        }),
      [handleDownloadLink, payeeType]
    );

    return (
      <div className={cx('link-container')}>
        <ButtonV2
          isTransparent
          rightIcon={<IconDownload />}
          type='button'
          onClick={handleUtf8}
        >
          {t('invoice_reports.csv_import_drawer.detail.utf_8')}
        </ButtonV2>
        <ButtonV2
          isTransparent
          rightIcon={<IconDownload />}
          type='button'
          onClick={handleShiftJis}
        >
          {t('invoice_reports.csv_import_drawer.detail.shift_jis')}
        </ButtonV2>
      </div>
    );
  }
);

SampleCsvDownloadButtons.displayName = 'SampleCsvDownloadButtons';
